import { Component, OnInit, AfterViewInit, Renderer, ElementRef } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

import { AccountService } from '../../../../services/account.service';
import { LoginModalService } from '../../../login/login-modal.service';
import { ParamUtils } from '../../../../shared/utils/param-utils';
import { User } from '../../../../models/user.model';
import { KeyAndPassword } from '../../../../models/key-and-password.model';

@Component({
    selector: 'qms-password-reset-finish',
    templateUrl: './password-reset-finish.component.html'
})
export class PasswordResetFinishComponent implements OnInit, AfterViewInit {
    public passwordMinLength = User.PASSWORD_MIN_LENGTH;
    public passwordMaxLength = User.PASSWORD_MAX_LENGTH; // TODO: move to constants

    public doNotMatch: boolean;
    public keyMissing: boolean;
    public success: boolean;

    public resetPassword: string;
    public confirmPassword: string;

    private modalRef: NgbModalRef;
    private key: string;

    constructor(private accountService: AccountService,
                private loginModalService: LoginModalService,
                private route: ActivatedRoute,
                private elementRef: ElementRef, private renderer: Renderer) {
    }

    ngOnInit() {
        this.success = null;
        this.resetPassword = null;
        this.confirmPassword = null;

        this.keyMissing = false;
        this.route.queryParams.subscribe((params) => {
            ParamUtils.parseString(params['key'], (key: string) => {
                this.key = key;
            }, () => {
                this.keyMissing = true;
            });
        });
    }

    ngAfterViewInit() {
        if (this.elementRef.nativeElement.querySelector('#password') != null) {
            this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#password'), 'focus', []);
        }
    }

    public finishReset() {
        this.doNotMatch = null;
        if (this.resetPassword !== this.confirmPassword) {
            this.doNotMatch = true;
        } else {
            const keyAndPassword = new KeyAndPassword(this.key, this.resetPassword);
            this.accountService.finishPasswordReset(keyAndPassword).subscribe(() => {
                this.success = true;
            }, () => {
                this.success = false;
            });
        }
    }

    public login() {
        this.modalRef = this.loginModalService.open();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/password/reset/password-reset-finish.component.ts